import {initImacScene} from "../components/imac";
import {initParallaxSection} from "../components/parallax-section";
import {initPhonesEffects} from "../components/phones-effects";

export function initMigcreditLanding() {
    if (!$('#migcredit_landing').length) return;
    initImacScene();

    initParallaxSection();
    initPhonesEffects();
}
